import SvgIcon from "@mui/material/SvgIcon";
import type { SvgIconProps } from "@mui/material/SvgIcon";

const Replicate = ({ style, children, ...props }: SvgIconProps) => (
  <SvgIcon {...props} style={{ ...style, fill: "none" }} viewBox="0 0 18 18">
    {children}<path d="M9 16.5C8.5875 16.5 8.23438 16.3531 7.94063 16.0594C7.64688 15.7656 7.5 15.4125 7.5 15V9C7.5 8.5875 7.64688 8.23438 7.94063 7.94063C8.23438 7.64688 8.5875 7.5 9 7.5H15C15.4125 7.5 15.7656 7.64688 16.0594 7.94063C16.3531 8.23438 16.5 8.5875 16.5 9V15C16.5 15.4125 16.3531 15.7656 16.0594 16.0594C15.7656 16.3531 15.4125 16.5 15 16.5H9ZM9 15H15V9H9V15ZM4.5 13.5V6C4.5 5.5875 4.64688 5.23438 4.94063 4.94063C5.23438 4.64688 5.5875 4.5 6 4.5H13.5V6H6V13.5H4.5ZM1.5 10.5V3C1.5 2.5875 1.64687 2.23438 1.94063 1.94063C2.23438 1.64687 2.5875 1.5 3 1.5H10.5V3H3V10.5H1.5Z" fill="currentColor"/>
  </SvgIcon>
);

export default Replicate;
